import { Drilling } from "./Drilling";
import { CountersinkHoles } from "./CountersinkHoles";
import { CounterboreHoles } from "./CounterboreHoles";
import cs from "./AdditionalProcessing.module.scss";

export const AdditionalPlasticProcessing = ({
  services,
  element,
  readOnly,
  onChange,
}) => {
  const params = element.parameters;

  return (
    <div className="AdditionalProcessing">
      <div className="h4 mb24">Dodatkowa obróbka tworzyw sztucznych</div>

      <div className={cs.services}>
        {services.map((service) => {
          switch (service._id) {
            case 129:
              if (
                readOnly &&
                (!params.holes?.drilledHoles ||
                  params.holes?.drilledHoles.length === 0)
              ) {
                return null;
              }

              return (
                <Drilling
                  holes={params.holes?.drilledHoles}
                  readOnly={readOnly}
                  onChange={onChange}
                />
              );
            case 131:
              return (
                <CountersinkHoles
                  holes={params.holes?.counter_sink_holes}
                  readOnly={readOnly}
                  onChange={onChange}
                />
              );
            case 132:
              return (
                <CounterboreHoles
                  holes={params.holes?.counter_bore_holes}
                  readOnly={readOnly}
                  onChange={onChange}
                />
              );
            default:
              return null;
          }
        })}
      </div>
    </div>
  );
};
